import { AccessServiceBase, WsAccess } from "./wsdl/ws_access/v1.17/ws_access.ts";

export {
    WsAccess
};

export class AccessService extends AccessServiceBase {
}
